<script setup>
import BaseText from "@/library/BaseText.vue";
import { computed } from "vue";
const props = defineProps({
  type: {
    type: String,
    default: "individual",
    validator: (value) => ["individual", "couple", "family"].includes(value),
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md"].includes(value),
  },
});

const textVariant = computed(() => {
  return props.size === "sm" ? "caption-semibold" : "headline-6-medium";
});
</script>

<template>
  <BaseText
    as="button"
    :variant="textVariant"
    class="button-plans"
    :class="[`button-plans--${props.type}`, `button-plans--${props.size}`]"
  >
    <slot />
  </BaseText>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
.button-plans {
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: $color-primary-100-light;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background-color: $color-primary-1;
    opacity: 0;

    @at-root .button-plans:hover#{&} {
      opacity: 0.1;
    }
  }

  @mixin background-gradient($color-start, $color-end) {
    background: linear-gradient(46deg, $color-start 31%, $color-end 100%);
  }

  &--individual {
    @include background-gradient($color-info, #fd9871);
  }

  &--couple {
    @include background-gradient($color-brand-2-90-light, #dbdf00);
  }

  &--family {
    @include background-gradient($color-brand-3-90-light, #2ab5dc);
  }

  &--sm {
    padding: 8px 12px;
  }

  &--md {
    padding: 16px 24px;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}
</style>
